import React from 'react';
import { WorkflowAssignDialog } from '@/components/WorkflowAssignDialog';
import type { ApprovalWorkflow as BackendApprovalWorkflow } from '@/types/workflow';
import type { Employee } from '@/types/timesheet';
import type { ApprovalWorkflow } from '../types';

interface WorkflowAssignDialogWrapperProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  approval: ApprovalWorkflow | null;
  employees: Employee[];
  onAssign: (
    workflowId: string,
    assignmentType: 'all' | 'selected',
    selectedEmployeeIds?: number[]
  ) => Promise<void>;
}

export const WorkflowAssignDialogWrapper: React.FC<WorkflowAssignDialogWrapperProps> = ({
  open,
  onOpenChange,
  approval,
  employees,
  onAssign,
}) => {
  if (!approval) return null;

  const workflow = {
    id: approval.id,
    name: approval.name,
    description: '',
    isActive: approval.status === 'Active',
    isDefault: false,
    createdAt: approval.lastModified,
    createdBy: 'system',
    version: 1,
    stages: [],
    totalStages: approval.stages,
    totalApprovers: 0,
    isInUse: approval.assignedEmployees > 0,
  } as unknown as BackendApprovalWorkflow;

  return (
    <WorkflowAssignDialog
      open={open}
      onOpenChange={onOpenChange}
      workflow={workflow}
      employees={employees}
      onAssign={onAssign}
    />
  );
};
